// extracted by css-extract-rspack-plugin
export default {"send-single":"send-single-gp5lHT","sendSingle":"send-single-gp5lHT","overflow":"overflow-fNReZW"};